<!-- 总交易报表 -->
<template>
  <div class="container">
    <!-- 搜索区域 -->
    <div class="search-area">
      <el-form ref="searchForm" :model="searchForm" :rules="searchRules">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="skuCode" :label="$t('商品编码(货号/条码)')" class="form-item-inline">
              <mg-autocomplete
                v-model="searchForm.skuCode"
                :placeholder="$t('请输入')"
                :fetch-suggestions="fetchGoodsSuggestions"
                :columns="[
                  { prop: 'skuCode', label: $t('商品编码'), width: '100px' },
                  { prop: 'skuName', label: $t('商品名称'), width: '300px' },
                  { prop: 'articleNo', label: $t('货号'), width: '120px' },
                  { prop: 'partNo', label: $t('料号'), width: '160px' },
                  { prop: 'skuBarcode', label: $t('条码'), width: '160px' },
                ]"
                value-key="skuCode"
                :select-when-matched-one="true"
                :limit="1"
                :trigger-on-focus="false"
                :highlight-first-item="true"
                @select="handleGoodsSelect"
                @enter="handleAutoCompleteEnter"
                style="width: 100%"
              >
                <!-- 添加表头模板 -->
                <template #header>
                  <span style="width: 100px">{{ $t('商品编码') }}</span>
                  <span style="width: 300px">{{ $t('商品名称') }}</span>
                  <span style="width: 120px">{{ $t('货号') }}</span>
                  <span style="width: 160px">{{ $t('料号') }}</span>
                  <span style="width: 160px">{{ $t('条码') }}</span>
                </template>
                <template #default="{ item }">
                  <span style="width: 100px">{{ item.skuCode }}</span>
                  <span style="width: 300px">{{ item.skuName }}</span>
                  <span style="width: 120px">{{ item.articleNo }}</span>
                  <span style="width: 160px">{{ item.partNo }}</span>
                  <span style="width: 160px">{{ item.skuBarcode }}</span>
                </template>
              </mg-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item prop="dateRange" :label="$t('入账日期')" class="form-item-inline">
              <div class="form-item-date">
                <el-date-picker
                  v-model="searchForm.dateRange"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  :default-time="['00:00:00', '23:59:59']"
                  :start-placeholder="$t('开始日期')"
                  :end-placeholder="$t('结束日期')"
                  @change="handleDateChange"
                  style="width: 100%"
                />
                <div class="shortcut-date">
                  <template v-for="date in shortcutDateList">
                    <span @click="handleShortcutDate(date)" :key="date.value">{{ date.label }}</span>
                  </template>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="search-buttons">
              <!--v-permission:plSearch="$route.meta.buttons"-->
              <el-button type="primary" @click="handleSearch">
                {{ $t('查询') }}
              </el-button>
              <el-button @click="handleReset">{{ $t('重置') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--@sort-change="handleMultiSortChange"-->
    <div class="table-content">
      <mg-vxe-table
        v-if="loaded"
        :autoLoad="false"
        ref="mgTable"
        :columns.sync="tableColumns"
        :api="getGoodsLedgerPage"
        :apiParams="queryForm"
        style="height: 100%"
        businessType="RETAIL_COM_Product_Ledger"
        :configurable="true"
        :formatData="handleFormatter"
        show-footer
        :summary-option="summaryOption"
        @column-change="columnChange"
        :wrapperHeight="`calc(100vh - ${$pxToRem(186)})`"
        :multiple-sort="true"
        :multi-sort-change="handleMultiSortChange"
      >
       <!-- :amount-columns="['beginAmt', 'changeAmt', 'endAmt']"
        :quantity-columns="['beginQty', 'changeQty', 'endQty']" -->
        <template #topright>
          <!-- v-permission:plExport="$route.meta.buttons"-->
          <mg-export-button @exporting="handleExporting" :disabled="!queryForm.skuCode"></mg-export-button>
        </template>


          <template #sourceBillType="{ row }">
            {{ sourceBillTypeMap[row.sourceBillType] }}
          </template>
          <template #changeTime="{ row }">
            {{ $format.datetime(row.changeTime) }}
          </template>
          <template #beginCostPrice="{ row }">
            {{ $format.amount(row.beginCostPrice) }}
          </template>
          <template #beginAmt="{ row }">
            {{ $format.amount(row.beginAmt) }}
          </template>
          <template #changeCostPrice="{ row }">
            {{ $format.amount(row.changeCostPrice) }}
          </template>
          <template #changeAmt="{ row }">
            {{ $format.amount(row.changeAmt) }}
          </template>
          <template #endCostPrice="{ row }">
            {{ $format.amount(row.endCostPrice) }}
          </template>
          <template #endAmt="{ row }">
            {{ $format.amount(row.endAmt) }}
          </template>



      </mg-vxe-table>
    </div>
  </div>
</template>
<script>
  import { getGoodsLedgerPage, exportExcel, sumGoodsLedger, getFastAddGoodsList } from '@/api/stock/goodsLedger'

  import { downloadFile } from '@/utils'
  export default {
    name: 'ProductLedger',
    data() {
      const startDate = dayjs().startOf('day').valueOf()
      const endDate = dayjs().endOf('day').valueOf()
      return {
        sourceBillTypeMap: Object.freeze({
          PURCHASE_RECEIVE_ORDER: this.$t('采购入库单'),
          PURCHASE_RETURN_APPLY_ORDER: this.$t('退货申请单'),
          PURCHASE_RETURN_ORDER: this.$t('采购退货单'),
          COST_ADJUST_ORDER: this.$t('成本调整单'),
          SALE_ORDER: this.$t('批发销售单'),
          SALE_RETURN_ORDER: this.$t('批发退货单'),
          MATERIAL_RECEIVE_ORDER: this.$t('领用单'),
          STOCK_BREAKAGE_ORDER: this.$t('盈亏单'),
          SYS_COST_ADJUST_ORDER: this.$t('系统调整单'),
          WAREHOUSE_TRANSFER_ORDER: this.$t('移仓单'),
          PURCHASE_ORDER: this.$t('采购订单'),
          DISTRIBUTION_REQUEST_ORDER: this.$t('补货请求单'),
          VERBAL_ORDER: this.$t('批发订单'),
          RATIO_AUDIT_ORDER: this.$t('返点调整单'),
          PRICE_ADJUST_ORDER: this.$t('基础售价调整单'),
          CUSTOMER_CREDIT_ORDER: this.$t('授信单'),
          SETTLEMENT_ORDER: this.$t('收款单'),
          DISCOUNT_ORDER: this.$t('折扣折让单'),
          PRE_PAY_ORDER: this.$t('预收款单'),
          RECONCILIATION_ORDER: this.$t('应收对账单'),
          PAYMENT_ORDER: this.$t('付款单'),
          SETTLEMENT_ORDER_PRE_PAY: this.$t('使用预收款'),
          SETTLEMENT_ORDER_DISCOUNT: this.$t('使用折扣折让'),
          SKU_PROCESS_ORDER: this.$t('商品加工单'),
          RETAIL_ORDER: this.$t('零售收银单'),
          RETAIL_RETURN_ORDER: this.$t('零售退货单'),
          PAYMENT_DISCOUNT_ORDER: this.$t('应付折让单'),
          RETAIL_SALE_ORDER: this.$t('收银订单'),
          RETAIL_SALE_RETURN_ORDER: this.$t('收银退单'),
          WM_GOODS: this.$t('外卖商品'),
        }),
        // 搜索表单数据
        searchForm: {
          skuCode: '',
          dateRange: [startDate, endDate],
        },
        queryForm: {
          page: 1,
          size: 50,
          skuCode: '',
          changeTimeStart: startDate,
          changeTimeEnd: endDate,
          sortBy: 'createTime:DESC;storageFtpId:ASC',
        },
        searchRules: {
          skuCode: [{ required: true, message: this.$t('请输入商品编码'), trigger: 'blur' }],
          dateRange: [{ required: true, message: this.$t('请选择交易日期'), trigger: 'blur' }],
        },
        dateRange: [startDate, endDate],

        exportColumns: [],

        tableColumns: [],

        summaryOption: { changeQty: 0 },

        loaded: false,
      }
    },

    computed: {
      shortcutDateList() {
        return [
          { label: this.$MGUI.i18n.t('昨'), type: 'day', value: -1 },
          { label: this.$MGUI.i18n.t('今'), type: 'day', value: 0 },
        ]
      },
    },

    async mounted() {
      this.tableColumns = [
        ...[
          { label: this.$t('序号'), type: 'seq', minWidth: 80 },
          { label: this.$t('入账时间'), prop: 'changeTime', slot: 'changeTime', sortable: true, minWidth: 160 },
          { label: this.$t('业务类型'), prop: 'sourceBillType', slot: 'sourceBillType', sortable: true, minWidth: 80 },
          { label: this.$t('单据号'), prop: 'billNo', minWidth: 120 },
          { label: this.$t('异动往来单位编码'), prop: 'transitionCode', minWidth: 100 },
          { label: this.$t('异动往来单位名称'), prop: 'transitionName', minWidth: 100 },
          { label: this.$t('单据备注'), prop: 'remark', minWidth: 100 },
          { label: this.$t('入账人'), prop: 'completeUserName', minWidth: 100 },
          { label: this.$t('期初数量'), prop: 'beginQty', align: 'right', minWidth: 80 },
          { label: this.$t('期初进价'), prop: 'beginCostPrice', slot: 'beginCostPrice', align: 'right', minWidth: 80 },
          { label: this.$t('期初进价金额'), prop: 'beginAmt', slot: 'beginAmt', align: 'right', minWidth: 100 },
          { label: this.$t('变动数量'), prop: 'changeQty', align: 'right', minWidth: 80 },
          {
            label: this.$t('变动进价'),
            prop: 'changeCostPrice',
            slot: 'changeCostPrice',
            align: 'right',
            minWidth: 80,
          },
          { label: this.$t('变动进价金额'), prop: 'changeAmt', slot: 'changeAmt', align: 'right', minWidth: 100 },
          { label: this.$t('期末数量'), prop: 'endQty', align: 'right', minWidth: 80 },
          { label: this.$t('期末进价'), prop: 'endCostPrice', slot: 'endCostPrice', align: 'right', minWidth: 80 },
          { label: this.$t('期末进价金额'), prop: 'endAmt', slot: 'endAmt', align: 'right', minWidth: 100 },
          { label: this.$t('商品编码'), prop: 'skuCode', minWidth: 100 },
          { label: this.$t('商品名称'), prop: 'skuName', minWidth: 120 },
          { label: this.$t('货号'), prop: 'articleNo', minWidth: 80 },
        ],
      ]

      this.loaded = true
    },

    methods: {
      getFastAddGoodsList,
      getGoodsLedgerPage,

      // 响应多列排序事件
      handleMultiSortChange({ sortList }) {
        console.log(sortList)
        // 拼接排序字段
        const list = sortList
          .map((item) => `${item.property === 'changeTime' ? 'changeTimestamp' : item.property}:${item.order}`)
          .join(';')
        this.queryForm.sortBy = list.length > 0 ? list : 'createTime:DESC;storageFtpId:ASC'

        // 重新查询数据
        if (this.$refs.mgTable && this.$refs.mgTable.loadData) {
          this.$refs.mgTable.pagination.page = 1
          this.$refs.mgTable.loadData()
        }
      },

      /**
       * 商品搜索建议
       */
      async fetchGoodsSuggestions(queryString, cb) {
        if (!queryString || queryString.trim().length < 1) {
          cb([])
          return
        }

        try {
          const response = await getFastAddGoodsList({ searchKey: queryString })
          cb(response.data || [])
        } catch (error) {
          console.error('搜索商品失败:', error)
          cb([])
        }
      },

      /**
       * 商品选择
       */
      handleGoodsSelect(item) {
        console.log("TIPS handleGoodsSelect:",item)
        this.queryForm.skuCode = item.skuCode
        this.handleSearch()
      },

      /**
       * 自动完成组件回车事件处理
       */
      handleAutoCompleteEnter() {
        // 当用户按下回车键时，如果已经选择了商品，则执行搜索
        // if (this.queryForm.skuCode) {
        //   this.handleSearch()
        // }
      },

      /**
       * 日期变化处理
       */
      handleDateChange(date) {
        if (date && date.length === 2) {
          this.queryForm.changeTimeStart = date[0]
          this.queryForm.changeTimeEnd = date[1]
          this.searchForm.dateRange = date
        } else {
          this.queryForm.changeTimeStart = ''
          this.queryForm.changeTimeEnd = ''
          this.searchForm.dateRange = []
        }
      },

      /**
       * 查询
       */
      async handleSearch() {
        await this.$nextTick()
        // 添加防重复调用逻辑
        if (this.loading) return

        try {
          // 验证表单
          await this.$refs.searchForm.validate()

          // 更新查询参数
          this.queryForm.skuCode = this.searchForm.skuCode
          if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
            this.queryForm.changeTimeStart = this.searchForm.dateRange[0]
            this.queryForm.changeTimeEnd = this.searchForm.dateRange[1]
          } else {
            this.queryForm.changeTimeStart = ''
            this.queryForm.changeTimeEnd = ''
          }

          // 重置页码并执行查询
          if (this.$refs.mgTable && this.$refs.mgTable.loadData) {
            this.$refs.mgTable.pagination.page = 1
            await this.$refs.mgTable.loadData()
          }
        } catch (error) {
          // 表单验证失败，不执行查询
          console.log('表单验证失败，不执行查询')
          return
        }
      },

      /**
       * 重置
       */
      handleReset() {
        this.queryForm.skuCode = ''
        this.searchForm.skuCode = ''
        const startDate = dayjs().startOf('day').valueOf()
        const endDate = dayjs().endOf('day').valueOf()
        this.dateRange = [startDate, endDate]
        this.searchForm.dateRange = [startDate, endDate]
        this.queryForm.changeTimeStart = startDate
        this.queryForm.changeTimeEnd = endDate

        // 重置后重新查询
        // this.handleSearch()
      },

      // async handleStatistics() {
      //   try {
      //     const res = await sumGoodsLedger(this.queryForm)
      //     if (res.data) {
      //       this.summaryOption = JSON.parse(res.data)
      //     }
      //   } catch (error) {
      //     console.error('获取合计数据失败:', error)
      //     this.summaryOption = {}
      //   }
      // },
      async handleStatistics() {
        try {
          const res = await sumGoodsLedger(this.queryForm)
          if (res.data) {
            // 检查返回的数据类型
            console.log('TIPS handleStatistics:', res.data)
            if (typeof res.data === 'string') {
              // 如果是字符串，尝试解析JSON
              try {
                this.summaryOption = JSON.parse(res.data)
              } catch (error) {
                console.error('解析合计数据失败:', error)
                this.summaryOption = {}
              }
            } else if (typeof res.data === 'object' && res.data !== null) {
              // 如果已经是对象，直接赋值
              this.summaryOption = res.data
            } else {
              // 如果是数字或其他类型，设置为空对象
              console.warn('合计数据格式不正确，期望对象但得到:', typeof res.data, res.data)
              this.summaryOption = {}
            }
          } else {
            this.summaryOption = {}
          }
        } catch (error) {
          console.error('获取合计数据失败:', error)
          this.summaryOption = {}
        }
      },

      /**
       * 数据格式化
       * 全量合计
       * @param items
       */
      async handleFormatter() {
        // if (!items || !Array.isArray(items)) {
        //   console.warn('handleFormatter: items is not an array', items)
        //   return
        // }

        // for (const item of items) {
        //   // 添加数据验证
        //   if (!item) continue

        //   // 根据支付类型匹配对应的支付金额
        //   try {
        //     if (item.customField) {
        //       const customField = JSON.parse(item.customField)
        //       Object.entries(customField).forEach(([key, value]) => {
        //         item[key] = value
        //       })
        //     }
        //   } catch (error) {
        //     console.error('解析customField失败:', error)
        //   }
        // }

        // for (const item of items) {
        //   // 根据支付类型匹配对应的支付金额
        //   const customField = JSON.parse(item.customField)
        //   Object.entries(customField).forEach(([key, value]) => {
        //     item[key] = value
        //   })
        // }

        // // 合计接口
        const { data } = await sumGoodsLedger(this.queryForm)
        console.log('TIPS handleFormatter:', data)
        let qty = JSON.parse(data)

         this.summaryOption = {
              changeQty: qty || 0
            }

        // 获取合计数据
        // await this.handleStatistics()
      },

      columnChange(columns) {
        this.exportColumns = columns
      },

      /**
       * 导出
       * @param done
       */
      handleExporting(done) {
        if (this.exportColumns.length === 0) this.exportColumns = this.tableColumns
        exportExcel({
          ...this.queryForm,
          includeFieldNames: this.exportColumns.filter((item) => item.prop && !item.hidden).map((item) => item.prop),
        })
          .then((data) => {
            downloadFile(data)
          })
          .finally(() => {
            done()
          })
      },

      handleShortcutDate(date) {
        const dayjs = this.dayjs().add(date.value, date.type)
        const startDate = dayjs.startOf(date.type).valueOf()
        const endDate = dayjs.endOf(date.type).valueOf()
        this.searchForm.dateRange = [startDate, endDate]
        this.queryForm.changeTimeStart = startDate
        this.queryForm.changeTimeEnd = endDate
      },
    },
  }
</script>
<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .search-area {
      background: #fff;
      padding: 20px;
      margin-bottom: 16px;
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      // 确保表单项在同一行显示
      .form-item-inline {
        display: flex;
        align-items: center;
        margin-bottom: 0;

        ::v-deep .el-form-item__label {
          width: auto;
          min-width: 120px;
          text-align: right;
          padding-right: 12px;
          font-size: 18px;
          color: black;
          flex-shrink: 0;
          line-height: 40px;
          font-weight: 500;
        }

        ::v-deep .el-form-item__content {
          flex: 1;
          line-height: 40px;
        }
      }

      .search-buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 40px;
        margin-top: 24px;

        .el-button {
          margin-right: 0;
          margin-left: 12px; // 按钮之间添加左边距
          // font-size: 14px;
          padding: 10px 20px;

          &:first-child {
            margin-left: 0;
          }
        }
      }
    }

    .table-content {
      flex: 1;
      height: 0;
    }
  }

  .form-item-date {
    position: relative;

    .shortcut-date {
      display: flex;
      align-items: center;
      position: absolute;
      right: 1px;
      top: 1px;

      &:hover {
        cursor: pointer;

        span:first-child {
          transform: translateX(-100%);
          border-radius: 0;
        }
      }

      span {
        width: 30px;
        height: 38px;
        display: block;
        text-align: center;
        background: #fff;
        border-radius: 0 2px 2px 0;
        position: absolute;
        right: 0;
        top: 1px;

        &:hover {
          color: $mg--color-primary;
        }

        &:first-child {
          transition: transform 200ms;
          transform: translateX(0);
          border-left: 1px #1a252a3d solid;
          border-right: 1px #1a252a3d solid;
        }
      }
    }

    &.range {
      ::v-deep {
        .el-input__icon.el-range__close-icon {
          position: relative;
          right: 22px;
          line-height: 32px;
          font-size: 18px;
        }
      }
    }
  }
</style>
